import { FC } from "react";
import { Environment } from "../app/App";
import ContractOps from "../operations/contract/ContractOps";
import OrgOps from "../operations/organization/OrgOps";
import UserOps from "../operations/user/UserOps";
import Entity, { IEntity } from "../results/Entity";
import './Detail.scss';

export type DetailProps = {
  entity: IEntity | null,
  environment: Environment,
};

const Detail: FC<DetailProps> = (props) => {

  return (
    <>
      <div className="detail-category">{props.entity?.type}</div>
      <section className="detail-content">
        <Entity entity={props.entity}/>
        {
          props.entity?.type === 'organization' &&
          <OrgOps
            entity={props.entity}
            environment={props.environment}
            ops={[
              'add_contract_admin',
              'add_contract_member',
              'add_teachers_to_organizations',
              'remove_user',
              'update_address',
              'verify_admin',
            ]}
          />
        }
        {
          props.entity?.type === 'contract' &&
          <ContractOps
            entity={props.entity}
            environment={props.environment}
            ops={[
              'add_admin',
              'add_students',
              'disassociate_students_from_contract',
              'migrate_students',
              'remove_admin',
              'add_students_with_csv',
              'delete_students_with_csv',
              'add_contract_admins_to_organizations',
              'list_users',
            ]}
          />
        }
        {
          props.entity?.type === 'user' &&
          <UserOps
            entity={props.entity}
            environment={props.environment}
            ops={[
              'set_password',
              'update_email',
              'upgrade_to_pro_teacher',
              'update_emails_with_csv',
              'list_contracts',
            ]}
          />
        }
      </section>
    </>
  );
}

export default Detail;
